package dev.kuml.portal.web.i18n.strings

import dev.kuml.portal.web.i18n.legal.LegalPages
import dev.kuml.portal.web.i18n.legal.LegalPagesDe
import dev.kuml.portal.web.i18n.legal.LegalPagesEn

/** The three legal-page LINKS (the row rendered by
 * [dev.kuml.portal.web.components.legalLinks]) plus the shared "back" affordance and the full,
 * structured page content ([pages], see [dev.kuml.portal.web.i18n.legal.LegalPages]). Kept as one
 * interface rather than splitting the link labels from the page content -- both are legal-page
 * concerns and a caller reaching for `t.legal.*` should find all of it in one place. */
public interface LegalStrings {
    public val imprintLink: String
    public val privacyLink: String
    public val termsLink: String
    public val backLink: String
    public val pages: LegalPages

    public val allPlainStrings: List<String> get() = listOf(imprintLink, privacyLink, termsLink, backLink)
}

public object LegalStringsDe : LegalStrings {
    override val imprintLink = "Impressum"
    override val privacyLink = "Datenschutz"
    override val termsLink = "AGB"
    override val backLink = "← Zurück"
    override val pages: LegalPages = LegalPagesDe
}

public object LegalStringsEn : LegalStrings {
    override val imprintLink = "Imprint"
    override val privacyLink = "Privacy"
    override val termsLink = "Terms"
    override val backLink = "← Back"
    override val pages: LegalPages = LegalPagesEn
}
